import * as mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters';

const state = {
  paypalToken: null,
  cardName: '',
  cardCPF: '',
  cardNumber: '',
  cardDate: '',
  cardCVC: '',
  instalmentAmount: 1,
  interestAmount: 0,
  totalAmount: 0,
  interests: {},
  billet: null,
  ame: null,
  pix: null,
  paypal: null,
  paypalPlus: null,
  ameOrderStatus: null,
  pixOrderStatus: null,
  paymentData: null,
  paypalClientId: null,
  partialValue: 0,
  partialError: false,
  keyPagSeguroDev:
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr+ZqgD892U9/HXsa7XqBZUayPquAfh9xx4iwUbTSUAvTlmiXFQNTp0Bvt/5vK2FhMj39qSv1zi2OuBjvW38q1E374nzx6NNBL5JosV0+SDINTlCG0cmigHuBOyWzYmjgca+mtQu4WczCaApNaSuVqgb8u7Bd9GCOL4YJotvV5+81frlSwQXralhwRzGhj/A57CGPgGKiuPT+AOGmykIGEZsSD9RKkyoKIoc0OS8CPIzdBOtTQCIwrLn2FxI83Clcg55W8gkFSOS6rWNbG5qFZWMll6yl02HtunalHmUlRUL66YeGXdMDC2PuRcmZbGO5a/2tbVppW6mfSWG3NPRpgwIDAQAB',
  keyPagSeguroBetaProd:
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvz261wzAL6ym9r2DxCr5IGEO19k7viViIErbAC8PqrPTkXtt/GAQlslon88v/DUE8s+/CPiXpanvbSsAalPXSrd+tnr/MEbOI26UlRiO7j/Jxs9zj3jQ2dF++KDdu+UL115gv83aNGZK4XxLqVl81TddNcKx4+D0mX2wlsu0OrYEVeIE5cCfOQ5Xz6PkKQlocDczPMmtK5dQ+hrgaNzRK6vLGX6lODOuuQYfLG15kizyULIiIbskopOEyMw6/euwqxAj/aNW0FRwUyxTwnxiK+C6gB0lOavfiTCM1bgZgwmeGxtpxCGyK0CtpOKn0GcGe2kqsk7NsE5WodnwgbYZLQIDAQAB',
  checkTerms: false,
  optIn: null,
  invoice: false,
  secure3dsOpen: false,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
